/** Side-effect-free member destinations shared by navigation and preview routing. */
export const LAKIKAVERI_INFO_CONTENT_PATH = '/lakikaveri-info';
export const EDUHOUSEN_VERKKOKOULUTUS_CONTENT_PATH = '/eduhousen-verkkokoulutus';
export const OIKEUSTURVAVAKUUTUS_CONTENT_PATH = '/oikeusturvavakuutus';
export const VAPAA_AJAN_TAPATURMAVAKUUTUS_CONTENT_PATH = '/vapaa-ajan-tapaturmavakuutus';
export const TYOSUHTEEN_PAATTAMINEN_CONTENT_PATH = '/tyosuhteen-paattaminen';
export const PUHETTA_PALKASTA_CONTENT_PATH = '/puhetta-palkasta';
export const JASENEDUT_CONTENT_PATH = '/jasenedut';
export const LAKIRUUTU_CONTENT_PATH = '/lakiruutu';

export const CONTENT_PAGE_ROUTE_PATHS = [
  LAKIKAVERI_INFO_CONTENT_PATH,
  EDUHOUSEN_VERKKOKOULUTUS_CONTENT_PATH,
  OIKEUSTURVAVAKUUTUS_CONTENT_PATH,
  VAPAA_AJAN_TAPATURMAVAKUUTUS_CONTENT_PATH,
  TYOSUHTEEN_PAATTAMINEN_CONTENT_PATH,
  PUHETTA_PALKASTA_CONTENT_PATH,
  JASENEDUT_CONTENT_PATH,
  LAKIRUUTU_CONTENT_PATH,
] as const;

export function resolveContentPagePath(linkSlug: string): string {
  const staticPath = `/${linkSlug}`;
  return CONTENT_PAGE_ROUTE_PATHS.some((path) => path === staticPath)
    ? staticPath
    : `/content/${linkSlug}`;
}
